import { useCallback } from 'react';
import adyenUtils from 'adyenthreeds2-js-utils/dist/threeds2-js-utils';
import { CardValidationError } from '../../../constants';
import { useDialog } from '../../../components/Dialog';
import { Psd2AuthData } from '../usePaymentMethodsQuery';
import { getContainerElement } from './getContainerElement';

const IFRAME_NAME = 'threeDSChallengeIframe';

export const useChallengeShopper = () => {
  const { showDialog, hideDialog, waitForDialog } = useDialog();

  const challengeShopper = useCallback(
    (psd2AuthData?: Psd2AuthData | null) =>
      new Promise<void>((resolve, reject) => {
        if (!psd2AuthData)
          return reject(new CardValidationError('challengeShopper: psd2AuthData missing'));

        const { acsURL, acsTransID, messageVersion, threeDSResponseServerTransID } = psd2AuthData;

        const challengeWindowSize = adyenUtils.config.validateChallengeWindowSize('02');
        const [width, height] = adyenUtils.config.getChallengeWindowSize(challengeWindowSize);

        const container = getContainerElement();

        const onMessage = (event: MessageEvent) => {
          if (event.data.type === 'ChallengeShopper') {
            window.removeEventListener('message', onMessage);
            hideDialog();

            const resultCode = event.data.data?.attributes?.result_code;

            if (resultCode === 'Authorised') return resolve();

            if (resultCode === 'Refused')
              return reject(new CardValidationError('challengeShopper: authorization refused'));

            const error = new CardValidationError('challengeShopper: unknown resultCode');
            error.networkError = { result: event.data };

            reject(error);
          }
        };

        window.addEventListener('message', onMessage);

        const form = adyenUtils.createForm(
          'cReqForm',
          acsURL,
          IFRAME_NAME,
          'creq',
          adyenUtils.base64Url.encode(
            JSON.stringify({
              threeDSServerTransID: threeDSResponseServerTransID,
              acsTransID,
              messageVersion,
              messageType: 'CReq',
              challengeWindowSize
            })
          )
        );

        showDialog({
          onHide: () => reject(new CardValidationError('challengeShopper: dialog closed by user'))
        });

        waitForDialog().then(dialog => {
          adyenUtils.createIframe(dialog, IFRAME_NAME, width, height);

          container.appendChild(form);
          form.submit();
          container.removeChild(form);
        });
      }),
    [showDialog, hideDialog, waitForDialog]
  );

  return challengeShopper;
};
